import React, { createContext, useState, useContext } from 'react';
import { Category, Items, Group } from './Item';

const CategoryContext = createContext();

export const CategoryProvider = ({ children }) => {
  const [categories, setCategories] = useState(Category);
  const [items, setItems] = useState(Items);
  const [groups, setGroups] = useState(Group);
  const contextValue = {
    categories,
    setCategories,
    items,
    setItems,
    groups,
    setGroups
  };
  return (
    <CategoryContext.Provider value={contextValue}>
      {children}
    </CategoryContext.Provider>
  );
};

export const useCategory = () => {
  const context = useContext(CategoryContext);
  if (!context) {
    throw new Error('useCategory must be used within a CategoryProvider');
  }
  return context;
};

